import { withRouter } from 'react-router';
import LoginRequired from 'project/components/login_required';

export default withRouter(LoginRequired);



// WEBPACK FOOTER //
// ./project/containers/login_required.js